import { useMutation } from "@tanstack/react-query";
import { addEntryDocument, removeEntryDocument } from "./entryDocuments.api";

/**
 * Adds and removes the documents a module entry holds itself. A saved entry is written at once
 * and the server's list replaces the local one; an entry not created yet keeps its files in the
 * form until the create request carries them. Failures reject, so the caller decides how to say so.
 */
const useEntryDocumentEditor = ({ moduleType, entryId, documents = [], onDocumentsChange }) => {
  const persisted = Boolean(entryId);
  const adding = useMutation({
    mutationFn: (doc) => addEntryDocument(moduleType, entryId, doc),
  });
  const removing = useMutation({
    mutationFn: (doc) => removeEntryDocument(moduleType, entryId, doc),
  });

  const add = async (doc) => {
    if (!persisted) {
      onDocumentsChange([...documents, doc]);
      return;
    }
    onDocumentsChange(await adding.mutateAsync({ name: doc.name, url: doc.url }));
  };

  const remove = async (doc) => {
    if (!persisted) {
      onDocumentsChange(documents.filter((item) => item.id !== doc.id));
      return;
    }
    onDocumentsChange(await removing.mutateAsync({ id: doc.id, url: doc.url }));
  };

  return { persisted, add, remove };
};

export default useEntryDocumentEditor;
